import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-validation-balloon',
  templateUrl: './validation-balloon.component.html',
  styleUrls: ['./validation-balloon.component.css']
})
export class ValidationBalloonComponent implements OnInit {

  @Input('control')control: FormControl;
  @Input('customMessages')customMessages: any = {};

  private messages: any = {
    required:   this.translate.instant('Обязательно для заполнения'),
    pattern:    this.translate.instant('Неправильный формат'),
    minlength:  this.translate.instant('Минимум {{requiredLength}} символов'),
    maxlength:  this.translate.instant('Максимум {{requiredLength}} символов'),
    min:        this.translate.instant('Число должно быть больше'),
    max:        this.translate.instant('Число должно быть меньше'),
    unique:     this.translate.instant('Значение не уникально'),
    phone:      this.translate.instant('Неправильный номер телефона')
  };

  constructor(
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.messages = Object.assign(this.messages, this.customMessages);
  }

  passDataToErrorMsg(msg: string, error: any) {
    let message = msg;
    Object.keys(error).forEach(propName => {
      message = message.replace(`{{${propName}}}`, error[propName]);
    });
    return message;
  }

  public get errorMessage() {
    const errors = this.control.errors;
    if (!errors) { return ''; }

    const errorType = Object.keys(errors)[0];
    const error = errors[errorType];
    const errorMessage = this.messages[errorType]
                      || errors.remote
                      || this.translate.instant('Поле заполнено неправильно');

    return this.passDataToErrorMsg(errorMessage, error);
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/validation-balloon/validation-balloon.component.ts